import React, { memo, useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import { Stars, SecondaryColors, Rating } from './types';

type Props = {
  className?: string;
  size?: number;
  stars: Stars;
  secondaryColors?: SecondaryColors;
  rating: Rating;
  halfStar: boolean;
};

const StarIcons = ({
  size = 16,
  stars,
  rating,
  secondaryColors,
  halfStar,
  className,
}: Props) => {
  const { market } = useContext(AppContext);

  return (
    <div
      style={{
        width: (size + 1) * stars.length,
        lineHeight: 0,
      }}
      className={className}
    >
      {stars.map(star => {
        const cdn = market && market.cdn ? market.cdn : 'https://cdn.pji.nu';
        let file = 'empty';

        if (halfStar && rating.whole === star) {
          file = secondaryColors ? 'alt-half' : 'primary-half';
        } else if (rating.whole >= star) {
          file = secondaryColors ? 'alt-full' : 'primary-full';
        }

        return (
          <img
            key={`star-${star}`}
            style={{
              width: size,
              height: size,
              marginRight: '1px',
            }}
            src={`${cdn}/g/rfe/icons/stars/${file}.svg`}
            alt=""
          />
        );
      })}
    </div>
  );
};

export default memo(StarIcons);
